import { writable } from 'svelte/store'

const defaults = {
  show_mobile_menu: false,
}

const createStore = () => {
  const { subscribe, update } = writable({
    ...JSON.parse(localStorage.getItem('store')),
    ...defaults,
  } || {})
  const setAttribute = (key, value) => update((global) => ({
    ...global,
    [key]: value,
  }))

  const reset = () => update(() => ({}))

  return {
    subscribe,
    setAttribute,
    reset,
  }
}

const store = createStore()
store.subscribe((value) => localStorage.setItem('store', JSON.stringify({ ...value, card_index: undefined })))
export default store
